import { useNavigate } from "react-router-dom";
import { useDataContext } from "../contexts/dataContext";
import jwt_decode from "jwt-decode";
import { useEffect } from "react";

export default function Logout() {
    const { setEsAsistente, setEsJefe } = useDataContext()
    const navigate = useNavigate()
    const token = sessionStorage.getItem('token')
    let decoded
    let id
    if (token) {
        decoded = jwt_decode(token);
        id = decoded.id;
    }
    useEffect(() => {
        (async () => {
            if (id) {
                await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/storage/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    },
                })
                
            }
        })();
    }, []);

    sessionStorage.clear()
    setEsAsistente(false);
    setEsJefe(false);
   // navigate("/auth/login");

    return (
        <>{window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT}/auth/login`)}</>
    )
}